// extracted by mini-css-extract-plugin
export default {"input__wrapper":"input_input__wrapper__OfeUM"};